import approvalInquiry from '@/lang/views/liff/ApprovalInquiry-th'
import attendanceForm from '@/lang/components/inquiryAndAttendance/AttendanceForm-th'
import averageTimeCheckInGraph from '@/lang/components/dashboard/AverageTimeCheckInGraph-th'
import billboard from '@/lang/components/message/Billboard-th'
import billboardAndIndividual from '@/lang/views/message/BillboardAndIndividual-th'
import blacklist from '@/lang/components/companySetting/Blacklist-th'
import blacklistForm from '@/lang/views/blacklist/BlacklistForm-th'
import savePlace from './components/companySetting/SavePlace-th'
import savePlaceForm from '@/lang/views/savePlace/SavePlaceForm-th'
import branch from '@/lang/components/companySetting/Branch-th'
import branchFormModal from '@/lang/components/modal/BranchFormModal-th'
import changePasswordModal from '@/lang/components/modal/ChangePasswordModal-th'
import checkInLocation from '@/lang/components/inquiryAndAttendance/CheckInLocation-th'
import checkinOnsite from '@/lang/views/liff/CheckinOnSite-th'
import checkInSale from '@/lang/views/liff/CheckinSale-th'
import checkInSaleList from '@/lang/views/liff/CheckinSaleList-th'
import companyHoliday from '@/lang/components/companySetting/CompanyHoliday-th'
import companyHolidayForm from '@/lang/components/modal/CompanyHolidayForm-th'
import companyProfile from '@/lang/components/companySetting/CompanyProfile-th'
import companySetting from '@/lang/views/CompanySetting-th'
import daily from '@/lang/components/report/Daily-th'
import dashboard from '@/lang/views/dashboard/Dashboard-th'
import deleteModal from '@/lang/components/modal/DeleteModal-th'
import departmemtFormModal from '@/lang/components/modal/DepartmemtFormModal-th'
import department from '@/lang/components/companySetting/Department-th'
import employee from '@/lang/views/employee/Employees-th'
import employeeForm from '@/lang/views/employee/EmployeeForm-th'
import employeeImport from '@/lang/views/employee/EmployeeImport-th'
import employeeImportImage from '@/lang/components/employee/EmployeeImportImage-th'
import employeeImportList from '@/lang/components/employee/EmployeeImportList-th'
import employeeSummaryBox from '@/lang/components/dashboard/EmployeeSummaryBox-th'
import errorModal from '@/lang/components/modal/ErrorModal-th'
import submitErrorModal from '@/lang/components/modal/SubmitErrorModal-th'
import exportEmployeeModal from '@/lang/components/modal/ExportEmployeeModal-th'
import groupAttendaceDetail from '@/lang/views/liff/GroupAttendaceDetail-th'
import groupHoliday from '@/lang/components/timeTableSetting/GroupHoliday-th'
import groupHolidayFormModal from '@/lang/components/modal/GroupHolidayFormModal-th'
import groupNormalWorkday from '@/lang/components/timeTableSetting/GroupNormalWorkday-th'
import groupWorkdayForm from '@/lang/views/timeTableSetting/GroupWorkdayForm-th'
import importEmployeeErrorModal from '@/lang/components/modal/ImportEmployeeErrorModal-th'
import importEmployeesFormModal from '@/lang/components/modal/ImportEmployeesFormModal-th'
import individual from '@/lang/components/message/Individual-th'
import infoModal from '@/lang/components/modal/InfoModal-th'
import infoModalCheckInDetail from '@/lang/components/modal/InfoModalCheckInDetail-th'
import inquiry from '@/lang/components/inquiryAndAttendance/Inquiry-th'
import inquiryLeave from '@/lang/components/inquiryAndAttendance/InquiryLeave-th'
import inquiryForm from '@/lang/components/inquiryAndAttendance/InquiryForm-th'
import inquiryQuickReview from '@/lang/components/dashboard/InquiryQuickReview-th'
import leaveQuota from '@/lang/components/companySetting/LeaveQuota-th'
import leaveType from '@/lang/components/companySetting/LeaveType-th'
import leaveTypeFormModal from '@/lang/components/modal/LeaveTypeFormModal-th'
import liff from '@/lang/views/liff/Liff-th'
import liffOvertimeRequest from '@/lang/views/liff/OvertimeRequest-th'
import lineRegisCodeModal from '@/lang/components/modal/LineRegisCodeModal-th'
import lineService from '@/lang/components/companySetting/LineService-th'
import logoutModal from '@/lang/components/modal/LogoutModal-th'
import manageAttendance from '@/lang/components/inquiryAndAttendance/ManageAttendance-th'
import messageModal from '@/lang/components/modal/MessageModal-th'
import monthly from '@/lang/components/report/Monthly-th'
import onsiteTodayTable from '@/lang/components/dashboard/OnsiteTodayTable-th'
import overtimeRequest from '@/lang/components/inquiryAndAttendance/OvertimeRequest-th'
import overtimeRequestForm from '@/lang/views/inquiryAndAttendance/OvertimeRequestForm-th'
import pin from '@/lang/views/Pin-th'
import profile from '@/lang/components/Profile-th'
import punchLog from '@/lang/components/inquiryAndAttendance/PunchLog-th'
import report from '@/lang/views/Report-th'
import resetPinForm from '@/lang/components/modal/ResetPinForm-th'
import sidebar from '@/lang/components/Sidebar-th'
import specialWorkday from '@/lang/components/timeTableSetting/SpecialWorkday-th'
import specialWorkdayFormModal from '@/lang/components/modal/SpecialWorkdayFormModal-th'
import statusAttendance from '@/lang/components/inquiryAndAttendance/StatusAttendance-th'
import successModal from '@/lang/components/modal/SuccessModal-th'
import { th } from 'vuetify/lib/locale'
import timeTableSetting from '@/lang/views/timeTableSetting/TimeTableSetting-th'
import toggleStatus from '@/lang/components/ToggleStatus-th'
import totalEmployeeGraph from '@/lang/components/dashboard/TotalEmployeeGraph-th'
import userFormModal from '@/lang/components/modal/UserFormModal-th'
import userManagement from '@/lang/components/companySetting/UserManagement-th'
import userProfile from '@/lang/views/UserProfile-th'
import visitor from '@/lang/views/visitor/Visitor-th'
import visitorActivity from '@/lang/components/visitor/VisitorActivity-th'
import visitorAttendance from '@/lang/components/visitor/VisitorAttendance-th'
import visitorForm from '@/lang/views/visitor/VisitorForm-th'
import weeklyCalendar from '@/lang/components/WeeklyCalendar-th'
import checkInLocationDetail from '@/lang/components/inquiryAndAttendance/CheckInLocationDetail-th'
import checkInOutLater from '@/lang/views/liff/CheckInOutLater-th.js'
import checkInOutApproval from '@/lang/views/liff/CheckInOutApproval-th.js'
import onSiteService from '@/lang/views/onSiteService/OnSiteService-th.js'
import onSiteServiceDetail from '@/lang/views/onSiteService/OnSiteServiceDetail-th.js'

export default {
    ...th,
    checkInLocation,
    dashboard,
    averageTimeCheckInGraph,
    employeeSummaryBox,
    inquiryQuickReview,
    onsiteTodayTable,
    totalEmployeeGraph,
    weeklyCalendar,
    sidebar,
    companySetting,
    companyProfile,
    branch,
    blacklist,
    blacklistForm,
    savePlace,
    savePlaceForm,
    branchFormModal,
    userManagement,
    department,
    lineService,
    billboardAndIndividual,
    billboard,
    individual,
    messageModal,
    companyHoliday,
    leaveQuota,
    leaveType,
    leaveTypeFormModal,
    inquiry,
    manageAttendance,
    inquiryForm,
    attendanceForm,
    employee,
    employeeForm,
    employeeImport,
    employeeImportImage,
    employeeImportList,
    importEmployeesFormModal,
    importEmployeeErrorModal,
    lineRegisCodeModal,
    timeTableSetting,
    groupNormalWorkday,
    specialWorkday,
    specialWorkdayFormModal,
    groupHoliday,
    groupHolidayFormModal,
    groupWorkdayForm,
    toggleStatus,
    report,
    daily,
    monthly,
    visitor,
    visitorForm,
    visitorActivity,
    visitorAttendance,
    deleteModal,
    statusAttendance,
    profile,
    userProfile,
    userFormModal,
    departmemtFormModal,
    companyHolidayForm,
    changePasswordModal,
    pin,
    resetPinForm,
    successModal,
    errorModal,
    submitErrorModal,
    exportEmployeeModal,
    groupAttendaceDetail,
    logoutModal,
    approvalInquiry,
    liff,
    infoModal,
    infoModalCheckInDetail,
    checkinOnsite,
    checkInSale,
    checkInSaleList,
    overtimeRequest,
    punchLog,
    liffOvertimeRequest,
    overtimeRequestForm,
    checkInLocationDetail,
    checkInOutLater,
    checkInOutApproval,
    onSiteService,
    onSiteServiceDetail,
    inquiryLeave
}
